import React, { useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import HelpDeskContent from "./HelpDeskContent";
import { OPEN_HELP_DESK_EVENT, registerHelpDeskOpen } from "../utils/helpDesk";

/**
 * Single app-wide Help Desk modal. Mount once near the app root.
 * HelpDeskButton and postMessage handlers call openHelpDeskModal().
 */
const HelpDeskModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => registerHelpDeskOpen(onOpen), [onOpen]);

  useEffect(() => {
    const handler = () => onOpen();
    window.addEventListener(OPEN_HELP_DESK_EVENT, handler);
    return () => window.removeEventListener(OPEN_HELP_DESK_EVENT, handler);
  }, [onOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Help Desk</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <HelpDeskContent isActive={isOpen} onSubmitted={onClose} />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HelpDeskModal;
